import { CompetitionStatusTileProps } from '../components/CompetitionStatusTile/CompetitionStatusTile';
import { format, parseISO } from 'date-fns';
import { ContentfulCompetition } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from '@jbhi-fi/components/src/Contentful/transformers/AssetTransformer';

export const contentfulApiCompetitionToCompetitionWinners = ({
  fields,
}: ContentfulCompetition): CompetitionStatusTileProps => {
  const coverImage = fields?.heroImage?.fields ? AssetTransformer.toImageProps(fields.heroImage) : null;

  return {
    heading: fields?.heading ?? '',
    coverImageSrc: coverImage?.src ?? '',
    coverImageAlt: coverImage?.alt ?? '',
    termsHref: fields?.termsConditions?.fields ? fields.termsConditions.fields.file.url : '',
    isClosed: fields?.endDate ? new Date(fields?.endDate).getTime() <= Date.now() : false,
    closeDate: fields?.endDate
      ? `${format(parseISO(fields?.endDate), 'hh:mmaaaa d MMM yyyy').replace(/\./g, '')} (AEST)`
      : undefined,
    hasWinners: Boolean(fields?.winners),
    winnerAnnouncementDate: fields?.winnerAnnouncementDate
      ? format(parseISO(fields?.winnerAnnouncementDate), 'd MMM yyyy')
      : undefined,
    winners: fields?.winners,
  };
};
